import { render, staticRenderFns } from "./contatti.vue?vue&type=template&id=51d9c21b&scoped=true"
import script from "./contatti.vue?vue&type=script&lang=js"
export * from "./contatti.vue?vue&type=script&lang=js"
import style0 from "./contatti.vue?vue&type=style&index=0&id=51d9c21b&prod&lang=scss&scoped=true"
import style1 from "./contatti.vue?vue&type=style&index=1&id=51d9c21b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d9c21b",
  null
  
)

export default component.exports